<template>
  <div>
    <div class="interval bg-color dark:bg-black z-30 px-20" :style="'width:'+width+'px;'">
      <div class="text-center text-lg pt-64">
        <UpgradePrompt />
      </div>
    </div>
  </div>
</template>

<script>
import UpgradePrompt from '@/components/visual/UpgradePrompt'
export default {
  components: { UpgradePrompt },
  props: ['scale'],
  computed: {
    width() {
      return Math.floor((26 * 3600) / this.scale)
    },
  },
}
</script>
